var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SectionHeader"},[(_vm.heading === '1')?[_vm._t("default"),_c('div',{staticClass:"titleJa"},[_vm._v(_vm._s(_vm.ja))])]:_vm._e(),(_vm.heading === '2')?_c('h2',[_c('span',[_vm._v(_vm._s(_vm.ja))])]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }